export const statusLabel = (labelmaker, statusCode, negoCode = -1, direction = -1) => {
  switch (statusCode) {
    case '0':
      switch (negoCode) {
        case '0':
          return labelmaker.t('common.status.waiting_request')
        case '10':
          switch (direction) {
            case 0:
              return labelmaker.t('common.status.negotiation_request_sent')
            case 1:
              return labelmaker.t('common.status.negotiation_request_received')
            default:
              return labelmaker.t('common.status.negotiation_request')
          }
        case '11':
          switch (direction) {
            case 0:
              return labelmaker.t('common.status.negotiation_response_received')
            case 1:
              return labelmaker.t('common.status.negotiation_response_sent')
            default:
              return labelmaker.t('common.status.negotiation_response')
          }
        default:
          return labelmaker.t('common.status.waiting_request')
      }
    case '1':
      return labelmaker.t('common.status.accepted_request')
    case '2':
      return labelmaker.t('common.status.modified_request')
    case '3':
      return labelmaker.t('common.status.aborted_request')
    case '4':
      return labelmaker.t('common.status.payment_order_generated')
    case '5':
      return labelmaker.t('common.status.payment_made')
    case '6':
      return labelmaker.t('common.status.inst_order_generated')
    case '7':
      return labelmaker.t('common.status.inst_made')
    case '8':
      return labelmaker.t('common.status.direct_payments')
    case '20':
      return labelmaker.t('common.status.information')
    default:
      return labelmaker.t('common.status.unknown')
  }
}

export const statusLabelHistory = (labelmaker, statusCode) => {
  switch (statusCode) {
    case '0':
      return labelmaker.t('common.status.waiting_request')
    case '1':
      return labelmaker.t('common.status.accepted_request')
    case '3':
      return labelmaker.t('common.status.aborted_request')
    case '4':
      return labelmaker.t('common.status.payment_order_generated')
    case '5':
      return labelmaker.t('common.status.payment_made')
    case '6':
      return labelmaker.t('common.status.inst_order_generated')
    case '7':
      return labelmaker.t('common.status.inst_made')
    case '10':
      return labelmaker.t('common.status.negotiation_request')
    case '11':
      return labelmaker.t('common.status.negotiation_response')
    case '20':
      return labelmaker.t('common.status.information')
    default:
      return labelmaker.t('common.status.unknown')
  }
}

export const statusIconHistory = (statusCode) => {
  switch (statusCode) {
    case '0':
      return 'icon-clock_forward'
    case '1':
      return 'icon-ok'
    case '2':
      return 'icon-ok'
    case '3':
      return 'icon-error'
    case '4':
      return 'icon-receipt'
    case '5':
      return 'icon-hand_money'
    case '6':
      return 'icon-receipt'
    case '7':
      return 'icon-hand_money'
    case '10':
      return 'icon-message'
    case '11':
      return 'icon-messages'
    case '12':
      return 'icon-messages'
    case '20':
      return 'icon-information'
    default:
      return 'icon-question'
  }
}

/* @author IRY - TLV 2020
* @brief Fonction centralisant tous les status utilisés sur MoneyRoad,
*         quelque soit le service utilisé
**/
export const statusIcon = (statusCode, negoCode) => {
  switch (statusCode) {
    case '0':
      switch (negoCode) {
        case '0':
          return 'icon-clock_forward'
        case '10':
          return 'icon-message'
        case '11':
          return 'icon-messages'
        case '12':
          return 'icon-messages'
        default:
          return 'icon-clock_forward'
      }
    case '1':
      return 'icon-ok'
    case '2':
      return 'icon-ok'
    case '3':
      return 'icon-error'
    case '4':
      return 'icon-receipt'
    case '5':
      return 'icon-hand_money'
    case '6':
      return 'icon-receipt'
    case '7':
      return 'icon-hand_money'
    case '8':
      return 'icon-money'
    case '20':
      return 'icon-information'
    default:
      return 'icon-question'
  }
}

export const statusColor = (statusCode, negoCode) => {
  switch (statusCode) {
    case '0':
      switch (negoCode) {
        case '0':
          return 'blueIcon'
        case '10':
          return 'orangeIcon'
        case '11':
          return 'orangeIcon'
        case '12':
          return 'orangeIcon'
        default:
          return 'blueIcon'
      }
    case '1':
      return 'greenIcon'
    case '2':
      return 'orangeIcon'
    case '3':
      return 'redIcon'
    case '4':
      return 'yellowIcon'
    case '5':
      return 'purpleIcon'
    default:
      return 'blackIcon'
  }
}

export const currencySymbol = (currency) => {
  let fromZoneCodeToSymbol = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'JPY': '¥',
    'RUB': '₽'
  }
  if (fromZoneCodeToSymbol[currency] != null) {
    return fromZoneCodeToSymbol[currency]
  }
  return currency
}

export const getSeenStatusBackground = (isRead) => {
  if (isRead === '0') {
    return '#e6e7e8'
  }
  return '#ffffff'
}

export const getSeenStatusFontWeight = (isRead) => {
  if (isRead === '1') {
    return '500'
  }
  return '700'
}



// WEBPACK FOOTER //
// ./src/helpers/labels.js